import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { STATUS_META, NEXT_STATUS, inputCls, fmtDate } from "./apUtils";

export function ApStatusPanel({ inv, onStatus, busy }) {
  const [status, setStatus] = useState(NEXT_STATUS[inv.status] || inv.status);
  const [note, setNote] = useState("");
  const [paidDate, setPaidDate] = useState(new Date().toISOString().slice(0, 10));
  const [method, setMethod] = useState("ACH");
  const [ref, setRef] = useState("");
  const submit = () => onStatus({ status, note: note || null, ...(status === "paid" ? { paid_date: paidDate, payment_method: method, payment_ref: ref || null } : {}) })
    .then(() => setNote(""));
  return (
    <div className="space-y-3" data-testid="ap-status-panel">
      {inv.status === "paid" && (
        <p className="text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2" data-testid="ap-paid-info">
          Paid {fmtDate(inv.paid_date)}{inv.payment_method ? ` · ${inv.payment_method}` : ""}{inv.payment_ref ? ` · ref ${inv.payment_ref}` : ""}
        </p>
      )}
      <div className="flex gap-2">
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="ap-status-select" className={inputCls}>
          {Object.entries(STATUS_META).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
        </select>
        <button onClick={submit} disabled={busy || status === inv.status} data-testid="ap-status-save"
          className="shrink-0 inline-flex items-center gap-1.5 bg-brand-ink text-brand-page rounded-full px-4 text-sm hover:opacity-90 disabled:opacity-40 transition-opacity duration-200">
          Update <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </div>
      {status === "paid" && inv.status !== "paid" && (
        <div className="grid grid-cols-3 gap-2">
          <input type="date" value={paidDate} onChange={(e) => setPaidDate(e.target.value)} data-testid="ap-paid-date" className={inputCls} />
          <select value={method} onChange={(e) => setMethod(e.target.value)} data-testid="ap-paid-method" className={inputCls}>
            {["ACH", "Check", "Wire", "Credit card", "Ramp Bill Pay", "Other"].map((m) => <option key={m}>{m}</option>)}
          </select>
          <input placeholder="Ref / check #" value={ref} onChange={(e) => setRef(e.target.value)} data-testid="ap-paid-ref" className={inputCls} />
        </div>
      )}
      <input placeholder="Note (optional)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="ap-status-note" className={inputCls} />
    </div>
  );
}

export function ApHistory({ history }) {
  return (
    <ol className="space-y-2 border-l border-brand-border ml-1" data-testid="ap-history">
      {[...(history || [])].reverse().map((h, i) => (
        <li key={i} className="pl-4 relative text-xs">
          <span className="absolute -left-[4px] top-1.5 h-2 w-2 rounded-full bg-brand-ink/50" />
          <p className="text-brand-ink">{h.status ? STATUS_META[h.status]?.label : "Update"} <span className="text-brand-tertiary">· {h.by} · {new Date(h.at).toLocaleString()}</span></p>
          {h.note && <p className="text-brand-muted">{h.note}</p>}
        </li>
      ))}
    </ol>
  );
}
